// extracted by mini-css-extract-plugin
module.exports = {"page":"index-module__page___1F5QB","connect":"index-module__connect___2t9OE"};